orders-planner-date-ui
  .row
    .col-12
      .ui-wrap.form-inline
        .prev-a-month.btn.btn-outline-success.btn-sm(onClick="{onClickPrevAMonth}" data-toggle="tooltip" data-placement="top" data-original-title="{opts.locale.back_one_month}") <<
        .prev-two-weeks.btn.btn-outline-success.btn-sm(onClick="{onClickPrevTwoWeeks}" data-toggle="tooltip" data-placement="top" data-original-title="{opts.locale.back_two_weeks}") <
        .date-wrap
          input.form-control(name="" value="{ start }" onInput="{this.onInput}" onChange="{this.onChange}" data-type="date")
        .next-two-weeks.btn.btn-outline-success.btn-sm(onClick="{onClickTwoWeeks}" data-toggle="tooltip" data-placement="top" data-original-title="{opts.locale.forward_two_weeks}") >
        .next-a-month.btn.btn-outline-success.btn-sm(onClick="{onClickNextAMonth}" data-toggle="tooltip" data-placement="top" data-original-title="{opts.locale.forward_one_month}") >>
  script(type="typescript").
    this.mixin('orders.planner.date-ui');
